export default __webpack_public_path__ + "static/media/eye.f272a9c1.svg";